export default __webpack_public_path__ + "static/media/craon24.9698f837.jpg";